export class Registry {
    constructor() {
        this.blockIds = [];
    }
    register(uniqueId) {
        this.blockIds.push(uniqueId);
    }
    unregister(uniqueId) {
        const i = this.blockIds.indexOf(uniqueId);
        if (i > -1) {
            this.blockIds.splice(i, 1);
        }
    }
    contains(uniqueId) {
        return this.blockIds.indexOf(uniqueId) !== -1;
    }
    get any() {
        return this.blockIds.length > 0;
    }
}
//# sourceMappingURL=Registry.js.map